import styled from 'styled-components';

export const SlideshowItem = styled.button<{ $clickable: boolean }>`
  outline: none;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;

  ${(props) =>
    !props.$clickable &&
    `
      pointer-events: none;
      cursor: default;
    `}
`;
